<script>
import columns from '@/pages/giftCard/wrapper/columns';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { mapActions, mapState } from 'vuex';
import ChangeProduct from '@/components/modals/Change-product.vue';

export default {
  data() {
    return {
      title: 'Gift wrapper',
      type: 'wrapper',
      columns: columns(),
      showEdit: false,
    };
  },
  components: {
    ChangeProduct,
    PageHeader,
  },
  methods: {
    ...mapActions({
      getProductsAction: 'products/getProducts',
    }),
    openEditWindow() {
      this.showEdit = true;
    },
  },
  mounted() {
    this.getProductsAction(this.type);
  },
  computed: {
    ...mapState({
      wrapper: (state) => state.products.productList,
    }),
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <div >
    <a-table
      :columns="columns"
      :dataSource="wrapper"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'actions'">
          <div >
            <a-button type="primary" @click="openEditWindow()">
              Edit
            </a-button>
            <div v-if="showEdit">
              <ChangeProduct
                v-model:show="showEdit"
                :isShow="showEdit"
                :product="record"
                :isNewProduct="false"
                button-text="Edit"
                title="Change product"
                type="wrapper"
              />
            </div>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>

<style scoped lang="scss">

</style>
